import { ProjectItemType } from "features/gallery/types";
import React from "react";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import climaIMG from "assets/images/clima_img.png";
import { smallShadow } from "theme/GlobalElements";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";

interface ProjectItemProps {
  item: ProjectItemType;
}

const ProjectItem: React.FC<ProjectItemProps> = ({ item }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product/${encodeURIComponent(item.alias)}`);
  };

  return (
    <ProjectItemContainer onClick={handleClick}>
      {/* image */}
      <ProductImage src={climaIMG} />
      <InfoContainer>
        <Count className={isMobile ? "text-sm" : "text-body"}>
          {item.count} {item.count === 1 ? "брой" : "броя"}
        </Count>
        <Title className={isMobile ? "text-sm" : "text-body"}>{item.title}</Title>
      </InfoContainer>
    </ProjectItemContainer>
  );
};

const ProjectItemContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 100%;
  ${smallShadow}
  cursor: pointer;
  margin-top: 18px;
`;

const ProductImage = styled.img`
  padding: 10px;
  width: 90px;
  height: 60px;

  @media only screen and (${device.laptop}) {
    width: 135px;
    height: 90px;
  }
`;

const InfoContainer = styled.div`
  padding: 10px;
  display: flex;
  flex-flow: column;
`;

const Count = styled.span`
  font-weight: 600;
  margin-bottom: 5px;
`;

const Title = styled.span``;

export default ProjectItem;
